import App from 'Components/global';
import fetchJson from 'Utils/fetchJson';
import { getGlobalContent } from 'Utils/getContent';
import getLocales from 'Utils/getLocales';
import { globalTrackerAPIRoot } from 'Constants/locations';

const Page = (props) => {
  return (<App {...props} />);
};

export default Page;

export const getStaticProps = async({ params }) => {
  // Content
  const content = getGlobalContent('en');

  // Statistics
  const globalStatistics = await fetchJson(`${globalTrackerAPIRoot}/statistics.json`);
  const globalCounts = await fetchJson(`${globalTrackerAPIRoot}/counts/all.json`);
  const regionalCounts = await fetchJson(`${globalTrackerAPIRoot}/regions/counts/all.json`);

  return ({
    props: {
      ...params,
      content,
      globalStatistics,
      globalCounts,
      regionalCounts,
      locale: 'en',
      locales: getLocales(),
    },
  });
};
